import React from "react";
import { Button, Tooltip, Text } from "@showitinc/showit-wc";

import { createButtonFromSelection } from "@/utils/PropertyUtils";
import uiPrefix from "@/utils/UiPrefixUtils";
import UserActions from "@/actions/UserActions";
import { TRACK_SOURCE_TOOLBAR } from "@/constants/AnalyticsConstants.mjs";

import styles from "../ElementToolbar.module.css";


const PotentialButtonToolbarButtons = ({ selectedElementsData, selectedElements, zoom }) => {
  const handleConvert = () => {
    UserActions.trackPostHogEvent("convert_to_button_clicked", {
      source: TRACK_SOURCE_TOOLBAR,
    });
    createButtonFromSelection(selectedElements);
  };

  return (
    <Tooltip delay={10} position="top-center" positionType="absolute">
      <Button
        variant="icon"
        data-e2e={uiPrefix("convert-to-button-btn")}
        className={styles.button}
        onClick={handleConvert}
        iconPrefix="convertButton"
        iconSize="20"
      />
      <span slot="content">
        <Text className={styles.label}>Convert to Button</Text>
      </span>
    </Tooltip>
  );
};

export default PotentialButtonToolbarButtons;